import { render, staticRenderFns } from "./FDOView.vue?vue&type=template&id=072de56c&scoped=true&"
import script from "./FDOView.vue?vue&type=script&lang=js&"
export * from "./FDOView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072de56c",
  null
  
)

export default component.exports